'use client';

import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { Toaster } from '@avodah-inc/ui';

export const ClientProviders = () => {
  return (
    <>
      {process.env.NODE_ENV === 'development' && (
        <ReactQueryDevtools initialIsOpen={false} />
      )}
      <Toaster />
    </>
  );
};
